// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const RemoveCircleRounded = React.forwardRef(function RemoveCircleRounded(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4 11H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z"/></SvgIcon>;
});
export default RemoveCircleRounded;
